module.exports = __webpack_public_path__ + "assets/img/36_1449.9e606e77.jpg";